// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"8fc31539","217":"4aabe63a"}[chunkId] + ".chunk.js";
};